import { EventLocation, SubEventBody } from '../../gds-api-client';

import { LocationState } from '../components/LocationContext';
import { bookingEntryAddressParser } from './addressComponentHelper';

export const populateSubEvent = (subEvent: SubEventBody, locationStore: LocationState = {}): SubEventBody => {
  let location;

  if (subEvent.type === 'Ceremony' && locationStore.CER) {
    const { gdsAddress, vendor_name } = bookingEntryAddressParser(locationStore.CER);
    location = { ...gdsAddress, name: vendor_name } as EventLocation;
  } else if (subEvent.type === 'Reception' && locationStore.REC) {
    const { gdsAddress, vendor_name } = bookingEntryAddressParser(locationStore.REC);
    location = { ...gdsAddress, name: vendor_name } as EventLocation;
  } else if (subEvent.type === 'WeddingEvent') {
    // eslint-disable-next-line
    location = subEvent.location;
  }

  return {
    id: subEvent.id || undefined,
    name: subEvent.name || '',
    time: subEvent.time || '',
    endTime: subEvent.endTime || '',
    visible: true,
    attire: subEvent.attire || '',
    notes: subEvent.notes || '',
    type: subEvent.type || 'WeddingEvent',
    location: {
      name: (location && location.name) || '',
      street1: (location && location.street1) || '',
      city: (location && location.city) || '',
      state: (location && location.state) || '',
      zip: (location && location.zip) || '',
      country: (location && location.country) || '',
    },
  };
};

export const populateSubEvents = (subEvents: SubEventBody[], locationStore: LocationState): SubEventBody[] => {
  if (!subEvents) {
    return [];
  }
  return subEvents.map(event => populateSubEvent(event, locationStore));
};
